import React, { useState } from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Tooltip, IconButton } from "@mui/material";

export default function InfoButton({ size = "medium", placement = "top", content = "Information", className = "" }) {
  const [open, setOpen] = useState(false);

  return (
    <Tooltip
      title={content}
      placement={placement}
      open={open}
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      arrow
      classes={{ tooltip: "bg-gray-800 text-white text-sm" }}
    >
      <IconButton
        size={size}
        onClick={() => setOpen((s) => !s)}
        className={`!p-1 !text-gray-600 hover:!text-gray-900 ${className}`}
      >
        <InfoOutlinedIcon fontSize={size === "small" ? "small" : "inherit"} />
      </IconButton>
    </Tooltip>
  );
}
